export enum LocalStorageItem {
  recentlyPlayed = "recently-played-v2",
  activeStationId = "active-station-id",
  audioQuality = "audio-quality",
}
